import React, { Component } from 'react'
import PropTypes from 'prop-types'
import iconAdd from 'images/add.svg'
import iconMinus from 'images/minus.svg'

import { uniqueIdentificationGenerator } from '../../utils/uniqueIdentificationGenerator'

class CounterInput extends Component {
  static propTypes = {
    /* The text that will be displayed along with the input */
    label: PropTypes.string,

    /* The id of the input */
    id: PropTypes.string,

    /* The input name */
    name: PropTypes.string.isRequired,

    /* The text that will be displayed below the input */
    helpText: PropTypes.string,

    /* The text that will be displayed below the input when an error is found */
    errorText: PropTypes.string,

    /* The text that will be displayed below the input when the input is valid */
    successText: PropTypes.string,

    /* Initial value, default is 0 */
    value: PropTypes.number,

    /* Minimum value, default is null */
    minValue: PropTypes.number,

    /* Maximum value, default is null */
    maxValue: PropTypes.number,

    /* Determine if the input is or not disabled */
    disabled: PropTypes.bool,

    /* Function that will be triggered when the value changes. May return true or false to wheter the new value is or not valid */
    validateValue: PropTypes.func,

    /* Callback for when the input changes */
    onChange: PropTypes.number,
  }

  state = {
    /* Stores the input value  */
    value: this.props.value || 0,

    /* Stores the information of wheter the input is or not on focus  */
    isOnFocus: false,

    /* Stores the information of wheter the input is or not valid  */
    isValid: null,
  }

  numberIsInRange(number) {
    const { minValue = null, maxValue = null } = this.props

    if (typeof minValue === 'number' && typeof maxValue === 'number') {
      if (number >= minValue && number <= maxValue) {
        return true
      }
    } else if (minValue === 'number') {
      if (number >= minValue) {
        return true
      }
    } else if (typeof maxValue === 'number') {
      if (number <= maxValue) {
        return true
      }
    } else {
      return true
    }
  }

  changeInputValue(number) {
    const { onChange = () => {}, validateValue } = this.props

    if (validateValue) {
      this.setState(
        {
          value: number,
          isValid: this.valueIsValid(number) && this.numberIsInRange(number),
        },
        onChange(number)
      )
    } else {
      if (this.numberIsInRange(number)) {
        this.setState({ value: number, isValid: true }, onChange(number))
      }
    }
  }

  onAdd() {
    const { value } = this.state
    this.changeInputValue(value + 1)
  }

  onSubtract() {
    const { value } = this.state
    this.changeInputValue(value - 1)
  }

  onChange(number) {
    
    this.changeInputValue(number)
  }

  valueIsValid(value) {
    const { validateValue } = this.props

    if (validateValue) {
      return validateValue(value)
    }
    return true
  }

  toggleFocus(focusState) {
    this.setState({ isOnFocus: focusState })
  }

  getClasses() {
    const { disabled } = this.props
    const { isOnFocus, isValid } = this.state
    return `
            ${disabled ? 'disabled' : ''}
            ${isOnFocus ? 'focus' : ''}
            ${isValid === false ? 'invalid' : ''}
            ${isValid === true ? 'valid' : ''}
        `
  }

  render() {
    const { label, helpText, errorText, successText, name, id } = this.props
    const { value, isValid } = this.state

    const customId = id || uniqueIdentificationGenerator('input-text_')
    const customName = name || uniqueIdentificationGenerator('input-text_')
    const classes = this.getClasses()
    return (
      <>
        <div className={`input-form-group ${classes}`}>
          {label && <label className='number-input-label'>{label}</label>}
          <div className='number-input-container'>
            <span className='minus' onClick={() => this.onSubtract()}>
              <img src={iconMinus} />
            </span>
            <input
              type='number'
              value={value}
              id={customId}
              name={customName}
              onChange={(e) => this.onChange(e.target.value)}
              onFocus={() => this.toggleFocus(true)}
              onBlur={() => this.toggleFocus(false)}
            />
            <span className='plus' onClick={() => this.onAdd()}>
              <img src={iconAdd} />
            </span>
          </div>
          {((helpText && isValid !== false && isValid !== true) ||
            (isValid === true && !successText)) && <small>{helpText}</small>}
          {errorText && isValid === false && (
            <small className='red'>{errorText}</small>
          )}
          {successText && isValid === true && (
            <small className='success'>{successText}</small>
          )}
        </div>
      </>
    )
  }
}

export default CounterInput
